"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _playerErrors = _interopRequireDefault(require("./utils/playerErrors"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Module that provides various utilities that can be helpful
 * when working with other modules from the VideoPlayback package.
 *
 * @module VideoPlayerUtils
 */
var _default = exports["default"] = {
  PlayerErrors: _playerErrors["default"]
};